type Vec3 = [number, number, number];

/**
 * One lamp the document hangs (`lights`, fluveria_graph::light::Light): a
 * material's Illuminance node asks what the lamps give a point. The web
 * edits no lamp; it keeps them and hands them to the shader that reads them
 * (rendering/webgpuRenderer.ts `drawValueData`, through the engine's
 * `packLights`).
 */
export interface DocumentLight {
  position: Vec3;
  /** Linear colour, per channel. */
  color: Vec3;
  intensity: number;
  /** Where the light has fallen to nothing. */
  radius: number;
  /** The flat opaque pieces this lamp's light stops at. */
  occluders?: Array<{ origin: Vec3; along: Vec3; across: Vec3 }>;
}

/**
 * The lamps of a snapshot as the engine parsed them, or none. Their shape is
 * the engine's to check (the codec refuses a malformed lamp); this keeps a
 * snapshot without the field, or with a stray value, from reading as lamps.
 */
export function documentLightsOf(value: unknown): DocumentLight[] {
  return Array.isArray(value) ? value as DocumentLight[] : [];
}
